import _ from "lodash";
import { i18n } from "lib/i18n";
import { enhancedT } from "./enhancedT";
/**
 *
 * This utility memoizes function while considering the current platform language
 * It assumes underline function fn takes single param that is an object
 *
 * @param {function} fn - the function that needs to be memoized
 * @param {function} resolver - a resolver that will be used to generate the key
 * @returns - the memoized function
 */

// Please prefer using GetMemoizedItemsFunction as that will support multiple languages as well as timezones and is more generic. We can add our own keys as well in it.

export const getMemoizedLangFunction = (fn, resolver = JSON.stringify) => {
  // fn will get the t function as one of its parameters
  const fnWrapper = params => {
    const t = enhancedT(i18n.t.bind(i18n));
    return fn({ ...params, t });
  };

  const resolverWrapper = params => {
    const { language } = i18n;
    return `${language}_${resolver(params)}`;
  };

  return _.memoize(fnWrapper, resolverWrapper);
};
